import { IconButton, Tooltip, tooltipClasses, useTheme } from "@mui/material";
import { ExpandSvg } from "@components/svgs/expand";

type ExpandButtonProps = {
  title?: string;
  disabled?: boolean;
  onClick?: () => void;
  fillColor?: string;

  [key: string]: any;
};

export const ExpandButton = ({
  title = "",
  disabled,
  onClick,
  fillColor,
  ...others
}: ExpandButtonProps) => {
  const { palette } = useTheme();

  return (
    <Tooltip
      title={title}
      enterDelay={0}
      placement="top"
      enterNextDelay={100}
      slotProps={{
        popper: {
          sx: {
            [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
              {
                marginBottom: "5px",
              },
          },
        },
      }}
    >
      <IconButton
        {...others}
        disableRipple
        disabled={disabled}
        sx={{
          p: 0,
          "&:hover": {
            borderColor: palette.primary[800],
            boxShadow: "none",
          },
          "&:disabled": {
            border: `1px solid ${palette.text.disabled}`,
            backgroundColor: palette.common.white,
            "&>svg>path": {
              fill: palette.text.disabled,
            },
          },
        }}
        onClick={onClick}
      >
        <ExpandSvg {...others} color={fillColor} />
      </IconButton>
    </Tooltip>
  );
};
